
const ConfigPage = {
// items debug draw
  DEBUG: false,

  // base vars
  DAYS_TOTAL: 24,

  // paths
  PKG_MAIN: 'advent2017/',
  PKG_DATA: 'advent2017-data/',
  PKG_SOUNDS: 'advent2017-sounds/',

  // css classes
  CSS_INSIDE: 'inside',
  CSS_OUTSIDE: 'outside',
  CSS_HOVER: 'do-hover',

  // static content
  FIXED_WINS: [
    'o-projektu',
    'napistenam',
    'soutez',
    'gramofon',
    'komiks',
    'galerie',
    'tradicnik',
    'vanocni-tv',
    'tapety',
    'omalovanky',
  ],
};

export default ConfigPage;



// WEBPACK FOOTER //
// ./src/js/page/helpers/ConfigPage.js